import React from "react";
import { Space } from "antd";
import { AxTable, AxTag, AxDivider, AxButton } from "@dynata/axiom3";

const dataSource = [
  {
    key: "1",
    name: "Mike1",
    age: 32,
    address: "10 Downing Street",
  },
  {
    key: "2",
    name: "John",
    age: 42,
    address: "10 Downing Street",
  },
  {
    key: "3",
    name: "Jane",
    age: 42,
    address: "10 Downing Street",
  },
  {
    key: "4",
    name: "Hashmi",
    age: 42,
    address: "10 Downing Street",
  },
  {
    key: "5",
    name: "Idrees Hashmi",
    age: 42,
    address: "10 Downing Street",
  },
];

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tag",
    render: () => (
      <Space size="middle">
        <AxTag color="dynata">tag 1</AxTag>
        <AxTag color="magenta">tag 2</AxTag>
      </Space>
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (text, record) => (
      <Space size="middle">
        <AxButton type="link" size="small">
          Invite {record.name}
        </AxButton>
        <AxButton type="link" size="small">
          Delete
        </AxButton>
      </Space>
    ),
  },
];

function onRowClick(record) {
  alert(record.name);
}

class Table extends React.Component {
  render() {
    return (
      <div className="section" id="table">
        <h3>Table</h3>
        <p>A table displays rows of data.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxTable
  size="large"
  bordered={true}
  columns={columns}
  cellSpace={32}
  dataSource={dataSource}
  onRow={(record) => {
    return {
      onClick: onRowClick.bind(this, record),
    };
  }}
  pagination={true}
/>`}</pre>

            <div className="prop-header">
              <p className="props-title">Props</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td>Table size</td>
                  <td>small | medium | large</td>
                  <td>Default is medium</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>twoColumn</td>
                  <td>Renders the 2-column variant styles</td>
                  <td>boolean</td>
                  <td>-</td>
                  <td>false</td>
                </tr>
                <tr>
                  <td>pagination</td>
                  <td>Whether to show pagination</td>
                  <td>boolean</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>bordered</td>
                  <td>Whether to show bordered table</td>
                  <td>boolean</td>

                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>columns</td>
                  <td>Columns of table</td>
                  <td>
                    <a href="#Column">ColumnsType</a>[]
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>components</td>
                  <td>Override default table elements</td>
                  <td>
                    <a href="https://github.com/react-component/table/blob/75ee0064e54a4b3215694505870c9d6c817e9e4a/src/interface.ts#L129">
                      TableComponents
                    </a>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>dataSource</td>
                  <td>Data record array to be displayed</td>
                  <td>object[]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>expandable</td>
                  <td>Config expandable content</td>
                  <td>
                    <a href="#expandable">expandable</a>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>footer</td>
                  <td>Table footer renderer</td>
                  <td>function(currentPageData)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>getPopupContainer</td>
                  <td>The render container of dropdowns in table</td>
                  <td>(triggerNode) =&gt; HTMLElement</td>
                  <td>() =&gt; TableHtmlElement</td>
                  <td></td>
                </tr>
                <tr>
                  <td>loading</td>
                  <td>Loading status of table</td>
                  <td>
                    boolean | <a href="/components/spin/#API">Spin Props</a>
                  </td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>locale</td>
                  <td>The i18n text including filter, sort, empty text, etc</td>
                  <td>object</td>
                  <td>
                    <a href="https://github.com/ant-design/ant-design/blob/6dae4a7e18ad1ba193aedd5ab6867e1d823e2aa4/components/locale/default.tsx#L19-L37">
                      Default Value
                    </a>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>pagination</td>
                  <td>
                    Config of pagination. You can ref table pagination{" "}
                    <a href="#pagination">config</a> or full{" "}
                    <a href="/components/pagination/">
                      <code>pagination</code>
                    </a>{" "}
                    document, hide it by setting it to <code>false</code>
                  </td>
                  <td>object</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>rowClassName</td>
                  <td>Row's className</td>
                  <td>function(record, index): string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>rowKey</td>
                  <td>
                    Row's unique key, could be a string or function that returns
                    a string
                  </td>
                  <td>string | function(record): string</td>
                  <td>
                    <code>key</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>rowSelection</td>
                  <td>
                    Row selection <a href="#rowSelection">config</a>
                  </td>
                  <td>object</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>scroll</td>
                  <td>
                    Whether the table can be scrollable,{" "}
                    <a href="#scroll">config</a>
                  </td>
                  <td>object</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>showHeader</td>
                  <td>Whether to show table header</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>showSorterTooltip</td>
                  <td>
                    The header show next sorter direction tooltip. It will be
                    set as the property of Tooltip if its type is object
                  </td>
                  <td>
                    boolean |{" "}
                    <a href="/components/tooltip/#API">Tooltip props</a>
                  </td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>size</td>
                  <td>Size of table</td>
                  <td>
                    <code>default</code> | <code>middle</code> |{" "}
                    <code>small</code>
                  </td>
                  <td>
                    <code>default</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>sortDirections</td>
                  <td>
                    Supported sort way, could be <code>ascend</code>,{" "}
                    <code>descend</code>
                  </td>
                  <td>Array</td>
                  <td>
                    [<code>ascend</code>, <code>descend</code>]
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>sticky</td>
                  <td>Set sticky header and scroll bar</td>
                  <td>
                    boolean |{" "}
                    <code>{`{offsetHeader?: number, offsetScroll?: number, getContainer?: () =&gt; HTMLElement}`}</code>
                  </td>
                  <td>-</td>
                  <td>4.6.0 (getContainer: 4.7.0)</td>
                </tr>
                <tr>
                  <td>summary</td>
                  <td>Summary content</td>
                  <td>(currentData) =&gt; ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>tableLayout</td>
                  <td>
                    The{" "}
                    <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/table-layout">
                      table-layout
                    </a>{" "}
                    attribute of table element
                  </td>
                  <td>
                    - | <code>auto</code> | <code>fixed</code>
                  </td>
                  <td>
                    -
                    <hr />
                    <code>fixed</code> when header/columns are fixed, or using{" "}
                    <code>column.ellipsis</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>title</td>
                  <td>Table title renderer</td>
                  <td>function(currentPageData)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>
                    Callback executed when pagination, filters or sorter is
                    changed
                  </td>
                  <td>
                    <code>{`function(pagination, filters, sorter, extra: { currentDataSource: [], action: <code>paginate</code> | <code>sort</code> | <code>filter</code> })`}</code>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onHeaderRow</td>
                  <td>Set props on per header row</td>
                  <td>function(columns, index)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onRow</td>
                  <td>Set props on per row</td>
                  <td>function(record, index)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/table/#API"
                      >
                        {`<Table />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div className="prop-header">
              <p className="props-title">Props: Column</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>align</td>
                  <td>The specify which way that column is aligned</td>
                  <td>
                    <code>left</code> | <code>right</code> | <code>center</code>
                  </td>
                  <td>
                    <code>left</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>className</td>
                  <td>The className of this column</td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>colSpan</td>
                  <td>Span of this column's title</td>
                  <td>number</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>dataIndex</td>
                  <td>
                    Display field of the data record, support nest path by
                    string array
                  </td>
                  <td>string | string[]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>defaultFilteredValue</td>
                  <td>Default filtered values</td>
                  <td>string[]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>filterResetToDefaultFilteredValue</td>
                  <td>
                    click the reset button, whether to restore the default
                    filter
                  </td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>defaultSortOrder</td>
                  <td>Default order of sorted values</td>
                  <td>
                    <code>ascend</code> | <code>descend</code>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>ellipsis</td>
                  <td>
                    The ellipsis cell content, not working with sorter and
                    filters for now.
                    <br />
                    tableLayout would be <code>fixed</code> when{" "}
                    <code>ellipsis</code> is <code>true</code> or{" "}
                    <code>{`{ showTitle?: boolean }`}</code>
                  </td>
                  <td>
                    boolean | <code>{`{showTitle?: boolean }`}</code>
                  </td>
                  <td>false</td>
                  <td>showTitle: 4.3.0</td>
                </tr>
                <tr>
                  <td>filterDropdown</td>
                  <td>Customized filter overlay</td>
                  <td>
                    ReactNode | (props:{" "}
                    <a href="https://github.com/ant-design/ant-design/blob/ecc54dda839619e921c0ace530408871f0281c2a/components/table/interface.tsx#L79">
                      FilterDropdownProps
                    </a>
                    ) =&gt; ReactNode
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>filterDropdownOpen</td>
                  <td>
                    Whether <code>filterDropdown</code> is visible
                  </td>
                  <td>boolean</td>
                  <td>-</td>
                  <td>4.23.0</td>
                </tr>
                <tr>
                  <td>filtered</td>
                  <td>
                    Whether the <code>dataSource</code> is filtered
                  </td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>filteredValue</td>
                  <td>Controlled filtered value, filter icon will highlight</td>
                  <td>string[]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>filterIcon</td>
                  <td>Customized filter icon</td>
                  <td>ReactNode | (filtered: boolean) =&gt; ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>filterMultiple</td>
                  <td>Whether multiple filters can be selected</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>filterMode</td>
                  <td>To specify the filter interface</td>
                  <td>'menu' | 'tree'</td>
                  <td>'menu'</td>
                  <td>4.17.0</td>
                </tr>
                <tr>
                  <td>filterSearch</td>
                  <td>Whether to be searchable for filter menu</td>
                  <td>boolean | function(input, record):boolean</td>
                  <td>false</td>
                  <td>boolean:4.17.0 function:4.19.0</td>
                </tr>
                <tr>
                  <td>filters</td>
                  <td>Filter menu config</td>
                  <td>object[]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>fixed</td>
                  <td>
                    (IE not support) Set column to be fixed: <code>true</code>
                    (same as left) <code>'left'</code> <code>'right'</code>
                  </td>
                  <td>boolean | string</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>key</td>
                  <td>
                    Unique key of this column, you can ignore this prop if
                    you've set a unique <code>dataIndex</code>
                  </td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>render</td>
                  <td>
                    Renderer of the table cell. The return value should be a
                    ReactNode
                  </td>
                  <td>function(text, record, index) {}</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>responsive</td>
                  <td>
                    The list of breakpoints at which to display this column.
                    Always visible if not set.
                  </td>
                  <td>
                    <a href="https://github.com/ant-design/ant-design/blob/015109b42b85c63146371b4e32b883cf97b088e8/components/_util/responsiveObserve.ts#L1">
                      Breakpoint
                    </a>
                    []
                  </td>
                  <td>-</td>
                  <td>4.2.0</td>
                </tr>
                <tr>
                  <td>shouldCellUpdate</td>
                  <td>Control cell render logic</td>
                  <td>(record, prevRecord) =&gt; boolean</td>
                  <td>-</td>
                  <td>4.3.0</td>
                </tr>
                <tr>
                  <td>showSorterTooltip</td>
                  <td>
                    If header show next sorter direction tooltip, override{" "}
                    <code>showSorterTooltip</code> in table
                  </td>
                  <td>
                    boolean | <a href="/components/tooltip/">Tooltip props</a>
                  </td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>sortDirections</td>
                  <td>
                    Supported sort way, override <code>sortDirections</code> in{" "}
                    <code>Table</code>, could be <code>ascend</code>,{" "}
                    <code>descend</code>
                  </td>
                  <td>Array</td>
                  <td>
                    [<code>ascend</code>, <code>descend</code>]
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>sorter</td>
                  <td>
                    Sort function for local sort, see{" "}
                    <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort">
                      Array.sort
                    </a>
                    's compareFunction. If you need sort buttons only, set to{" "}
                    <code>true</code>
                  </td>
                  <td>function | boolean</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>sortOrder</td>
                  <td>
                    Order of sorted values: <code>'ascend'</code>{" "}
                    <code>'descend'</code> <code>false</code>
                  </td>
                  <td>boolean | string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>title</td>
                  <td>Title of this column</td>
                  <td>
                    ReactNode |{" "}
                    <code>{`({(sortOrder, sortColumn, filters)}) =>`}</code>
                    ReactNode
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>width</td>
                  <td>
                    Width of this column (
                    <a href="https://github.com/ant-design/ant-design/issues/13825#issuecomment-449889241">
                      width not working?
                    </a>
                    )
                  </td>
                  <td>string | number</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onCell</td>
                  <td>Set props on per cell</td>
                  <td>function(record, rowIndex)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onFilter</td>
                  <td>
                    Function that determines if the row is displayed when
                    filtered
                  </td>
                  <td>function(value, record) =&gt; boolean</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onFilterDropdownOpenChange</td>
                  <td>
                    Callback executed when <code>filterDropdownOpen</code> is
                    changed
                  </td>
                  <td>function(open) {}</td>
                  <td>-</td>
                  <td>4.23.0</td>
                </tr>
                <tr>
                  <td>onHeaderCell</td>
                  <td>Set props on per header cell</td>
                  <td>function(column)</td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div className="prop-header">
              <p className="props-title">Props: ColumnGroup</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>title</td>
                  <td>Title of the column group</td>
                  <td>ReactNode</td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>

            <div className="prop-header">
              <p className="props-title">Props: Pagination</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>position</td>
                  <td>
                    Specify the position of <code>Pagination</code>, could be
                    <code>topLeft</code> | <code>topCenter</code> |{" "}
                    <code>topRight</code> |<code>bottomLeft</code> |{" "}
                    <code>bottomCenter</code> | <code>bottomRight</code>
                  </td>
                  <td>Array</td>
                  <td>
                    [<code>bottomRight</code>]
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="prop-header">
              <p className="props-title">Props: expandable</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>childrenColumnName</td>
                  <td>The column contains children to display</td>
                  <td>string</td>
                  <td>children</td>
                  <td></td>
                </tr>
                <tr>
                  <td>columnTitle</td>
                  <td>Set the title of the expand column</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td>4.23.0</td>
                </tr>
                <tr>
                  <td>columnWidth</td>
                  <td>Set the width of the expand column</td>
                  <td>string | number</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>defaultExpandAllRows</td>
                  <td>Expand all rows initially</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>defaultExpandedRowKeys</td>
                  <td>Initial expanded row keys</td>
                  <td>string[]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>expandedRowClassName</td>
                  <td>Expanded row's className</td>
                  <td>function(record, index, indent): string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>expandedRowKeys</td>
                  <td>Current expanded row keys</td>
                  <td>string[]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>expandedRowRender</td>
                  <td>Expanded container render for each row</td>
                  <td>function(record, index, indent, expanded): ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>expandIcon</td>
                  <td>
                    Customize row expand Icon. Ref{" "}
                    <a href="https://codesandbox.io/s/fervent-bird-nuzpr">
                      example
                    </a>
                  </td>
                  <td>function(props): ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>expandRowByClick</td>
                  <td>
                    Whether to expand row by clicking anywhere in the whole row
                  </td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>fixed</td>
                  <td>
                    Whether the expansion icon is fixed. Optional true{" "}
                    <code>left</code> <code>right</code>
                  </td>
                  <td>boolean | string</td>
                  <td>false</td>
                  <td>4.16.0</td>
                </tr>
                <tr>
                  <td>indentSize</td>
                  <td>Indent size in pixels of tree data</td>
                  <td>number</td>
                  <td>15</td>
                  <td></td>
                </tr>
                <tr>
                  <td>rowExpandable</td>
                  <td>Enable row can be expandable</td>
                  <td>(record) =&gt; boolean</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>showExpandColumn</td>
                  <td>Show expand column</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td>4.18.0</td>
                </tr>
                <tr>
                  <td>onExpand</td>
                  <td>Callback executed when the row expand icon is clicked</td>
                  <td>function(expanded, record)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onExpandedRowsChange</td>
                  <td>Callback executed when the expanded rows change</td>
                  <td>function(expandedRows)</td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div className="prop-header">
              <p className="props-title">Props: rowSelection</p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>checkStrictly</td>
                  <td>
                    Check table row precisely; parent row and children rows are
                    not associated
                  </td>
                  <td>boolean</td>
                  <td>true</td>
                  <td>4.4.0</td>
                </tr>
                <tr>
                  <td>columnTitle</td>
                  <td>Set the title of the selection column</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>columnWidth</td>
                  <td>Set the width of the selection column</td>
                  <td>string | number</td>
                  <td>
                    <code>32px</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>fixed</td>
                  <td>Fixed selection column on the left</td>
                  <td>boolean</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>getCheckboxProps</td>
                  <td>Get Checkbox or Radio props</td>
                  <td>function(record)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>hideSelectAll</td>
                  <td>Hide the selectAll checkbox and custom selection</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td>4.3.0</td>
                </tr>
                <tr>
                  <td>preserveSelectedRowKeys</td>
                  <td>
                    Keep selection <code>key</code> even when it removed from{" "}
                    <code>dataSource</code>
                  </td>
                  <td>boolean</td>
                  <td>-</td>
                  <td>4.4.0</td>
                </tr>
                <tr>
                  <td>renderCell</td>
                  <td>
                    Renderer of the table cell. Same as <code>render</code> in
                    column
                  </td>
                  <td>function(checked, record, index, originNode) {}</td>
                  <td>-</td>
                  <td>4.1.0</td>
                </tr>
                <tr>
                  <td>selectedRowKeys</td>
                  <td>Controlled selected row keys</td>
                  <td>string[] | number[]</td>
                  <td>[]</td>
                  <td></td>
                </tr>
                <tr>
                  <td>selections</td>
                  <td>
                    Custom selection <a href="#selection">config</a>, only
                    displays default selections when set to <code>true</code>
                  </td>
                  <td>object[] | boolean</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>type</td>
                  <td>
                    <code>checkbox</code> or <code>radio</code>
                  </td>
                  <td>
                    <code>checkbox</code> | <code>radio</code>
                  </td>
                  <td>
                    <code>checkbox</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>Callback executed when selected rows change</td>
                  <td>
                    function(selectedRowKeys, selectedRows, info:{" "}
                    <code>{`{type}`}</code>)
                  </td>
                  <td>-</td>
                  <td>
                    <code>info.type</code>: 4.21.0
                  </td>
                </tr>
                <tr>
                  <td>onSelect</td>
                  <td>Callback executed when select/deselect one row</td>
                  <td>function(record, selected, selectedRows, nativeEvent)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onSelectAll</td>
                  <td>Callback executed when select/deselect all rows</td>
                  <td>function(selected, selectedRows, changeRows)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onSelectInvert</td>
                  <td>Callback executed when row selection is inverted</td>
                  <td>function(selectedRowKeys)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onSelectNone</td>
                  <td>Callback executed when row selection is cleared</td>
                  <td>function()</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onSelectMultiple</td>
                  <td>
                    Callback executed when row selection is changed by pressing
                    shift
                  </td>
                  <td>function(selected, selectedRows, changeRows)</td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div className="prop-header">
              <p className="props-title">Props: scroll</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>scrollToFirstRowOnChange</td>
                  <td>
                    Whether to scroll to the top of the table when paging,
                    sorting, filtering changes
                  </td>
                  <td>boolean</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>x</td>
                  <td>
                    Set horizontal scrolling, can also be used to specify the
                    width of the scroll area, could be number, percent value,
                    true and{" "}
                    <a href="https://developer.mozilla.org/zh-CN/docs/Web/CSS/width#max-content">
                      'max-content'
                    </a>
                  </td>
                  <td>string | number | true</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>y</td>
                  <td>
                    Set vertical scrolling, can also be used to specify the
                    height of the scroll area, could be string or number
                  </td>
                  <td>string | number</td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>

            <div className="prop-header">
              <p className="props-title">Props: selection</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>key</td>
                  <td>Unique key of this selection</td>
                  <td>string</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>text</td>
                  <td>Display text of this selection</td>
                  <td>ReactNode</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>onSelect</td>
                  <td>Callback executed when this selection is clicked</td>
                  <td>function(changeableRowKeys)</td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>

            <pre>{`const dataSource = [
  {
    key: "1",
    name: "Mike1",
    age: 32,
    address: "10 Downing Street",
  },
  {
    key: "2",
    name: "John",
    age: 42,
    address: "10 Downing Street",
  },
  {
    key: "3",
    name: "Jane",
    age: 42,
    address: "10 Downing Street",
  },
  {
    key: "4",
    name: "Hashmi",
    age: 42,
    address: "10 Downing Street",
  },
  {
    key: "5",
    name: "Idrees Hashmi",
    age: 42,
    address: "10 Downing Street",
  },
];

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tag",
    render: () => (
      <Space size="middle">
        <AxTag color="dynata">tag 1</AxTag>
        <AxTag color="magenta">tag 2</AxTag>
      </Space>
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (text, record) => (
      <Space size="middle">
        <a>Invite {record.name}</a>
        <a>Delete</a>
      </Space>
    ),
  },
];

function onRowClick(record) {
  alert(record.name);
}

<AxTable
  size="large"
  bordered={true}
  columns={columns}
  cellSpace={32}
  dataSource={dataSource}
  onRow={(record) => {
    return {
      onClick: onRowClick.bind(this, record),
    };
  }}
  pagination={true}
/>`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Small | Medium | Large
        </AxDivider>

        <Space direction="vertical" size={30}>
          <AxTable
            size="small"
            bordered={false}
            columns={columns}
            cellSpace={32}
            dataSource={dataSource}
            onRow={(record) => {
              return {
                onClick: onRowClick.bind(this, record),
              };
            }}
            pagination={true}
          />
          <AxTable
            size="medium"
            columns={columns}
            cellSpace={32}
            dataSource={dataSource}
            onRow={(record) => {
              return {
                onClick: onRowClick.bind(this, record),
              };
            }}
            pagination={false}
          />

          <AxTable
            size="large"
            columns={columns}
            cellSpace={32}
            dataSource={dataSource}
            onRow={(record) => {
              return {
                onClick: onRowClick.bind(this, record),
              };
            }}
            pagination={false}
          />
        </Space>
      </div>
    );
  }
}
export default Table;
